import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const listOnePartnerMaster = createSlice({
  name: "listOnePartnerMaster",
  initialState: {
    data: [],
    isLoading: false,
    isFirst: true,
  },
  reducers: {
    raise_api_call_list_partner_one_master: (state, action?) => {
      state.isLoading = true;
    },
    list_success_partner_one_master: (state, action) => {
      console.log(action.payload);
      state.data = action.payload;
      state.isFirst = true;
      state.isLoading = false;
    },
    list_failure_partner_one_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    partner_master_one_isFirst: (state, action) => {
      state.isFirst = false;
    },
  },
});
export default listOnePartnerMaster.reducer;
export const {
  raise_api_call_list_partner_one_master,
  list_success_partner_one_master,
  list_failure_partner_one_master,
  partner_master_one_isFirst,
} = listOnePartnerMaster.actions;
